window.van = window.van || {};
van.cacheSelectors = function () {
  van.cache = {
    // General
    $html                    : $('html'),
    $body                    : $('body'),
    // Collection Pages
    $changeView              : $('.change-view'),
    // Product Page
    $productImage            : $('#ProductPhotoImg'),
    $thumbImages             : $('#ProductThumbs').find('a.product-single__thumbnail'),
    $productImageWrap: $('#ProductPhoto')
  };
};
van.init = function () {
  van.cacheSelectors();
  van.productImageSwitch();
  van.sliderClickCallback();
};
van.getHash = function () {
  return window.location.hash;
};
van.productPage = function (options) {
  var moneyFormat = options.money_format,
      variant = options.variant,
      selector = options.selector;
  // Selectors
  var $productImage = $('#ProductPhotoImg'),
      $addToCart = $('#AddToCart'),
      $productPrice = $('#ProductPrice'),
      $comparePrice = $('#ComparePrice'),
      $saleTag = $('.Productsaletag'),
      $quantityElements = $('#quantity'),
      $addToCartText = $('#AddToCartText'),
      $addToCartTextDiscount = $('#AddToCart > span');
  if (variant) {
    // Update variant image, if one is set
    if (variant.featured_image) {
      var newImg = variant.featured_image,
          el = $productImage[0];
      Shopify.Image.switchImage(newImg, el, van.switchImage);
    }
    // Select a valid variant if available
    if (variant.available) {
      // Available, enable the submit button, change text, show quantity elements
      $addToCart.removeClass('disabled').prop('disabled', false);
      $addToCartText.html(" ADD TO CART");
      
      $productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );
      
      $quantityElements.removeClass('disabled').prop('disabled', false);
      $addToCartTextDiscount.show();
      $comparePrice.show();
      $saleTag.show();
    } else {
      // Sold out, disable the submit button, change text, hide quantity elements
      $addToCart.addClass('disabled').prop('disabled', true);
      $addToCartText.html(" SOLD OUT");
      $productPrice.html(" SOLD OUT");
      $quantityElements.addClass('disabled').prop('disabled', true);
      $addToCartTextDiscount.hide();
      $comparePrice.hide();
      $saleTag.hide();
      
    }
     // Regardless of stock, update the product price
     //$productPrice.html( Shopify.formatMoney(variant.price, moneyFormat) );

      // Also update and show the product's compare price if necessary
      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(Shopify.formatMoney(variant.compare_at_price, moneyFormat)).show();
      } else {
        //$comparePrice.hide();
        $comparePrice.html(Shopify.formatMoney(variant.price + 500 , moneyFormat));
      }
  } else {
    // The variant doesn't exist, disable submit button.
    // This may be an error or notice that a specific variant is not available.
    // To only show available variants, implement linked product options:
    //   - http://docs.shopify.com/manual/configuration/store-customization/advanced-navigation/linked-product-options
    $addToCart.addClass('disabled').prop('disabled', true);
    $addToCartText.html("Unavailable");
    $productPrice.html(" SOLD OUT");
    //$addToCartText.html(" SOLD OUT");
    $quantityElements.addClass('disabled').prop('disabled', true);
    $addToCartTextDiscount.hide();
    $comparePrice.hide();
    $saleTag.hide();
  }
};
van.productImageSwitch = function () {
  if (van.cache.$thumbImages.length) {
    // Switch the main image with one of the thumbnails
    // Note: this does not change the variant selected, just the image
    van.cache.$thumbImages.on('click', function(evt) {
      evt.preventDefault();
      var newImage = $(this).attr('href');
      van.switchImage(newImage, null, van.cache.$productImage);
    });
  }
};
van.sliderClickCallback = function () {
  $('.product-single__thumbnail img').click(function(e){
    e.preventDefault();
    var variant_img = $(this).attr('src');
    //var product_id = $(this).parent('a').parent('li').parent('ul').data('product');
    var product_id = $('#ProductThumbs').data('product');
    //alert(product_id);
    if($("#productSelect--"+product_id+" option[data-image='"+variant_img+"']").val() !== undefined && $("#productSelect--"+product_id+" option[data-image='"+variant_img+"']").attr("disabled") === undefined){
      var option1 = $("#productSelect--"+product_id+" option[data-image='"+variant_img+"']").data('option1');
      var option2 = $("#productSelect--"+product_id+" option[data-image='"+variant_img+"']").data('option2');
      var option3 = $("#productSelect--"+product_id+" option[data-image='"+variant_img+"']").data('option3');

        //if(option1 !== ""){
        //  $(".AddToCartForm--"+product_id).find("select[data-option='option1']").val(option1).change();
       // }
        if(option2 !== ""){
          $(".AddToCartForm--"+product_id).find("input[value='"+option2+"']").attr("checked", "true").change();
        }
        //if(option3 !== ""){
        //  $(".AddToCartForm--"+product_id).find("input[value='"+option3+"']").attr("checked", "true").change();
        //}
      
    }
  });
};

van.switchImage = function (src, imgObject, el) {
  // Make sure element is a jquery object
  var $el = $(el);
  $el.attr('src', src);
  var zoomSrc = src.replace('_medium','_1024x1024').replace('_large','_1024x1024');
  $el.attr('data-nv-zoom-img-url', zoomSrc);
  var w = window.innerWidth;
  if (w>767){
    $(function() {
      van.productImageZoom();
    });
  }
};
van.productImageZoom = function () {
  if (!van.cache.$productImageWrap.length || van.cache.$html.hasClass('supports-touch')) {
    return;
  }
  // Destroy zoom (in case it was already set), then set it up again
  van.cache.$productImageWrap.trigger('zoom.destroy');
  van.cache.$productImageWrap.addClass('nv_img_zoom').zoom({
    url: van.cache.$productImage.attr('data-nv-zoom-img-url')
  });
};
// Initialize 
$(van.init);

